import React, { useEffect } from 'react';
import { Modal, Form, Input, message } from 'antd';
import { useSaveRoleMutation } from '../../services/settings.service';

const RolesPermissionsModal = ({ visible, role, onClose, onSuccess }) => {
  const [form] = Form.useForm();
  const [saveRole, { isLoading }] = useSaveRoleMutation();

  // Set form values when editing
  useEffect(() => {
    if (role) {
      form.setFieldsValue({
        name: role.name,
        description: role.description || '',
      });
    } else {
      form.resetFields();
    }
  }, [role, form]);

  // Handle form submission
  const handleSubmit = async (values) => {
    try {
      const data = {
        ...values,
        ...(role?.id && { id: role.id }),
      };

      const result = await saveRole(data).unwrap();
      message.success(`Role ${role ? 'updated' : 'created'} successfully`);
      form.resetFields();
      onSuccess(result.data);
    } catch (error) {
      message.error(error?.data?.message || `Failed to ${role ? 'update' : 'create'} role`);
    }
  };

  // Handle modal close
  const handleCancel = () => {
    form.resetFields();
    onClose();
  };

  return (
    <Modal
      title={role ? 'Edit Role' : 'Add Role'}
      open={visible}
      onOk={() => form.submit()}
      onCancel={handleCancel}
      okText={role ? 'Update' : 'Create'}
      confirmLoading={isLoading}
      width={500}
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={handleSubmit}
        autoComplete="off"
      >
        <Form.Item
          label="Role Name"
          name="name"
          rules={[
            { required: true, message: 'Please enter role name' },
            { min: 2, message: 'Role name must be at least 2 characters' },
            { max: 50, message: 'Role name must not exceed 50 characters' },
          ]}
        >
          <Input placeholder="Enter role name" />
        </Form.Item>

        <Form.Item
          label="Description"
          name="description"
          rules={[
            { max: 255, message: 'Description must not exceed 255 characters' },
          ]}
        >
          <Input.TextArea
            placeholder="Enter role description (optional)"
            rows={3}
          />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default RolesPermissionsModal;
